export default __webpack_public_path__ + "118e5ff4.jpg";